class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.searchButton = document.querySelector('.search__button');
    
    this.input.addEventListener('input', this.toggleResetButton.bind(this));
    this.resetButton.addEventListener('click', this.onResetButtonClick.bind(this));
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
      if (this.searchButton) this.searchButton.style.display = 'none';
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
      if (this.searchButton) this.searchButton.style.display = 'block';
    }
  }

  onResetButtonClick(event) {
    event.preventDefault();
    this.input.value = '';
    this.toggleResetButton();
    this.input.focus();
  }
}

customElements.define('search-form', SearchForm);
